<template>
    <div class="main">
        <ul class="report_list">
            <li v-for="(item, i) in reportList" :key="i">
                <input
                    :id="item.type"
                    class="radio"
                    type="radio"
                    name="radios"
                    :value="item.text"
                    v-model="checkedValue"
                />
                <label :for="item.type">{{ item.text }}</label>
            </li>
        </ul>
        <div class="report_content">
            <textarea
                class="report_content_ipt"
                type="text"
                placeholder="详情描述…"
                v-model="reportContent"
            />
        </div>

        <div class="report_img" v-if="more108">
            <div class="report_image" :key="item" v-for="(item,i) in image">
                <img :src="item">
                <i @click="delFn(i)"></i>
            </div>


            <div class="report_upload" v-if="image.length < 3" @click="upload">
            </div>

            
        </div>

        <p v-if="more108" class="up_tip">上传图片({{image.length}}/{{maxNum}})</p>

        <div class="border"></div>

        <div class="report_box">
            <div
                :class="{ report_btn: true, isChecked: isChecked }"
                @click="postReport"
            >
                举报
            </div>
        </div>
        
        <a class="to_secretary" href="www.baidu.com?l_id=108388#AiGuPiao_DirectMessages">
            如有任何问题均可联系爱股票小秘书
        </a>

        <div class="popback" v-if="success">
            <div class="popup">
                <h3>举报成功</h3>
                <p>感谢您的反馈，我们收到并核实举报信息后将后立即处理，并将处理结果以站内私信的形式发送给您!</p>
                <div class="line">	</div>
                    <a href="reload#AiGuPiao_GoBack" class="sure_btn">好</a>
            </div>
        </div>
       
    </div>
</template>
<script>
import ReportApi from '@/api/report/index.js'
import "@/utils/flexible";
export default {
    name: "Report",
    data() {
        return {
            checkedValue: "",
            u_id: this.$route.query.u_id,
            id: this.$route.query.id,
            kind:this.$route.query.kind,
            appversion:this.$route.query.appversion,
            kind:this.$route.query.kind,
            reportContent: "",
            reportList: [
                {
                    type: "a",
                    text: "垃圾广告",
                },
                {
                    type: "b",
                    text: "人身攻击",
                },
                {
                    type: "c",
                    text: "敏感时政",
                },
                {
                    type: "d",
                    text: "黄赌毒",
                },
                {
                    type: "e",
                    text: "抄袭剽窃",
                },
                {
                    type: "f",
                    text: "欺诈信息",
                },
                {
                    type: "g",
                    text: "诱导行为",
                },
                {
                    type: "h",
                    text: "其他",
                },
            ],
            loading: false,
            image:[],//上传展示的
            maxNum:3,
            success:false,
        };
    },
    mounted(){
        if(this.more108){
            window.srNativeCallH5Method = (data) => {
                let params = null;
                if(this.source == 'ios') {
                    params = JSON.parse(data);
                } else {
                    params = this.handleSpecialCharacters(data);
                }
                if(params.method_name == 'send_photo_url') {
                    //接收app传过来的图片地址
                    this.image = [...this.image,...params.params.urls];
                } 
            };
        }
    },
    components: {},
    computed: {
        isChecked() {
            return this.checkedValue !== "";
        },
        images(){
            //传给接口的
            return this.image.join(',');
        },
        restNum(){
            return (this.maxNum - this.image.length).toString();
        },
        more108(){
            return this.appversion && this.compareVersion(this.appversion, "10.8.0") >= 0;
        }
    },
    created() {
        this.fetchData();
        if(typeof this.u_id == 'object'){
            //会有传两遍的情况
            this.u_id = this.u_id[0];
        }    
    },
    methods: {
        handleSpecialCharacters(jsonStr) {
            let obj = {};
            if (jsonStr && Object.prototype.toString.call(jsonStr) == "[object String]" && jsonStr != 'null') {
                jsonStr = jsonStr.replace(/\n/g, "\<br/>");
                obj = JSON.parse(jsonStr)
            }
            return obj;
        },
        fetchData() {
            console.log(1233333);
        },
        postReport() {
            if (this.isChecked && !this.loading) {
                this.loading = true;
                this.reportFn();
            }
        },
        async reportFn() {
            console.info()
            let params = {
                u_id: this.u_id,
                msg_id: this.id,
                msg_kind: this.kind,
                report_kind: this.checkedValue,
                report_info:this.reportContent,
                images:this.images,
            }

            let res = await ReportApi.msgReport(params)
            if(res.data.rslt == "succ") {
                this.success = true;
                this.checkedValue = "";
                this.reportContent = "";
                this.image = [];
            }
            else{
                alert(res.data.info);
            }
            this.loading = false;
        },
        delFn(i){
            this.image.splice(i,1)
        },
        upload(){
            if (this.more108) {
                this.$srH5CallNativeMethodApp('call_native_photo',{
                    maxCount: this.restNum,//最多选择个数
                })
            } else {
                alert('请升级到最新版本');
            }
        },
        compareVersion(v1, v2) {
            if (v1 == v2) {
                return 0;
            }
            var vs1 = v1.split(".").map(a => parseInt(a));
            var vs2 = v2.split(".").map(a => parseInt(a));

            var length = Math.min(vs1.length, vs2.length);
            for (var i = 0; i < length; i++) {
                if (vs1[i] > vs2[i]) {
                    return 1;
                } else if (vs1[i] < vs2[i]) {
                    return -1;
                }
            }
            if (length == vs1.length) {
                return -1;
            } else {
                return 1;
            }
        }
    },
};
</script>
<style scoped lang="scss">
@import "~@/assets/sass/global.scss";
.main {
    
    background: #fff;
    color: #333333;
    min-height: 100vh;
}
.report_list {
    padding-top: rem2(8px);
    background: #ffffff;
    display: flex;
    flex-wrap: wrap;

    > li {
        width: 50%;
        height: rem2(50px);
        display: flex;
        align-items: center;
        padding: 0 rem2(15px);
        box-sizing: border-box;
        font-size: rem2(15px);
        > input {
            display: none;
        }
        > label {
            display: flex;
            align-items: center;
        }
        > input[type="radio"] + label:before {
            content: "";
            display: inline-block;
            width: rem2(10px);
            height: rem2(10px);
            padding: rem2(3px);
            border: rem2(1.5px) solid #d7d7d7;
            border-radius: 50%;
            background: #f5f5f5;
            margin-right: rem2(10px);
        }
        > input[type="radio"]:checked + label:before {
            content: "";
            display: inline-block;
            border: rem2(1.5px) solid #ff4443;
            background: #ff4443 content-box;
        }
    }
}
.report_content {
    margin-top: rem2(20px);
    box-sizing: border-box;
    padding: 0 rem2(12px);
    > .report_content_ipt {
        width: 100%;
        height: rem2(82px);
        background: #ffffff;
        line-height: rem2(24px);
        font-size: rem2(14px);
        padding:  rem2(5px) rem2(11px);
        box-sizing: border-box;
        border-radius: rem2(2.5px);
        border:  rem2(.75px) solid #E8E8E8;
    }
}
.report_img{
    padding: 0 rem2(12px);
    margin-top: rem2(15px);
    display: flex;
    >div{
        width: rem2(80px);
        height: rem2(80px);
        border-radius: rem2(2.5px);
        border: rem2(.75px) solid #E8E8E8;
        margin-right: rem2(15px);
    }
    .report_upload{
        background: url(../../assets/img/add_img.png) no-repeat;
        background-size: rem2(28px);
        background-position: center; 
    }
    .report_image{
        position: relative;
        >img{
            width: 100%;
            height: 100%;

            border-radius: rem2(2.5px);
            border: rem2(.75px) solid #E8E8E8;
        }
        >i{
            display: inline-block;
            width: rem2(20px);
            height: rem2(20px);
            position: absolute;
            right: 0;
            top: 0;
            background: url(../../assets/img/del_img.png);
            background-size: 100%;
        }
    }
}
.report_box {
    padding: rem2(20px) rem2(15px);
    > .report_btn {
        width: 100%;
        height: rem2(41px);
        line-height: rem2(41px);
        color: #ffffff;
        font-size: rem2(17px);
        text-align: center;
        background: #d8d8d8;
        border-radius: rem2(6px);
        &.isChecked {
            background: #ff4443;
        }
    }
}
.to_secretary {
    font-size: rem2(14px);
    color: #1d88d0;
    text-align: center;
    display: block;
}
.up_tip{
    font-size: rem2(12px);
    color: #939393;
    line-height: rem2(24px);
    padding: rem2(5px) rem2(12px);
}
.border{
    height: rem2(10px);
    background: #F5F6F7;
}

//成功弹窗
.popback{width: 100vw;height: 100vh;background: rgba(0,0,0,0.5);position: fixed;top: 0;z-index: 100;}
.popup{
    width: rem2(260px);margin: rem(300px) auto;
    border-radius: rem2(5px);background: #fff;
    padding: 0 rem2(17px);
    font-size: rem2(14px);box-sizing: border-box;z-index: 1000;

    h3{
        text-align: center;margin: rem2(15px) 0;
        padding-top: rem2(15px);font-weight: 600;
        font-size: rem2(16px);
    }
    p{
        text-align: center;font-size: rem2(14px);
        line-height: 1.5;color: #000;font-weight: 500;
    }
    .line{
        height: rem2(1px);background: #ddd ;width: 115%;
        transform: translateX(-6.5%);margin-top: rem2(18px);
    }
    .sure_btn{
        color: #589aff;display: block;margin: 0px auto;width: 115%;
        transform: translateX(-6.5%);
        height: rem2(40px);line-height: rem2(40px);text-align: center;
    }
}


</style>
